<template>
  <section class="hero content is-top">
    <div class="columns">
      <div class="column is-narrow">
        <svg-icon icon="server" class="icon is-large"/>
      </div>
      <div class="column">
        <h2 class="is-marginless">Initializing case</h2>
        <p><small>Please wait while information about your case is gathered...</small></p>
      </div>
    </div>
  </section>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
export default {
  name: 'start',
  components: {
    SvgIcon
  },
  data () {
    return {
      data: {}
    }
  },
  created () {
    // c
  }
}
</script>
